import React from 'react';
import {GoogleMap} from '@react-google-maps/api';

interface MapProps {
  center?: google.maps.LatLng | google.maps.LatLngLiteral | undefined;
  zoom: number;
  containerStyleClassName: string;
  onLoad(map: google.maps.Map): void;
  children: any;
}

function Map({
  center,
  zoom,
  containerStyleClassName,
  onLoad,
  children,
}: MapProps) {
  return (
    <GoogleMap
      mapContainerClassName={containerStyleClassName}
      center={center}
      zoom={zoom}
      onLoad={onLoad}>
      {children}
    </GoogleMap>
  );
}

export default Map;
